import React, {Component, Fragement} from 'react'
import {Row, Col, Steps, Tabs, message, Tooltip,} from 'antd'
import axios from 'axios'
import './order-info.less'
import {splitStr} from '../../utills/subStringUtill'
import {getOrderDetails, getOrderDelivery, getOrderTrails, baseUrl, reqFileList, getPackages} from '../../api'
import {
    DELIVERY_TYPE, DELIVERY_TYPE_MIX, DELIVERY_TYPE_HIGHWAY, DELIVERY_TYPE_AIR,
    PLAN_DELIVERY_TYPE
} from '../../utills/constants'
import OrderFileComponent from "../../components/bus/order-file"
import OrderBoxFile from "../track-edit/order-box-file";
import {YgIcon,} from '../../components/yg-icon'

const {TabPane} = Tabs
const {Step} = Steps

export default class OrderInfo extends Component {

    state = {
        id: '',
        orderId: '',
        order: [],
        packageManageVos: [],  // 商品列表,
        consignorVo: {},
        deliveryPlaceVo: {},
        visible: false,
        notifyPartyVo: {},
        trailNo: '',//轨迹号
        deliveryTrailDo: [],
        currentStep: 0,
        fileList: [],
        boxNo: '',
        factoryNo: '',
        carNo: '',
        mobileurl: '',
        supplierList: [],
    }

    getOrderDetails = async (id) => {
        let result = await getOrderDetails(id)
        if (result.code === 200) {
            const order = result.data
            const {
                consignorVo, deliveryPlaceVo, notifyPartyVo,
                boxRentStation, boxReturnStation, supplierList
            } = order
            this.setState({
                consignorVo,
                deliveryPlaceVo,
                notifyPartyVo,
                order,
                //packageManageVos:packageManageVos,
                commitDt: order.commitDt, boxRentStation, boxReturnStation, supplierList
            })
        } else if (result.code === 401) {
            this.props.history.replace('/login')
        }

    }
    goods = async (orderId, page = 1, pageSize = 20) => {
        let result = await getPackages({orderId, pageNum: page, pageSize});
        if (result.code === 200) {
            if (result.data) {
                this.setState({
                    page,
                    pageSize,
                    total: result.data.total,
                    packageManageVos: result.data.rows,
                })
            }
        } else {
            message.error(result.message)
            return false;
        }
    };
    // 查询 轨迹号
    getOrderDelivery = async (id) => {
        let result = await getOrderDelivery(id)
        if (result.code === 200) {
            const order = result.data;
            if (order && order.length > 0) {
                let boxNo = '';
                let factoryNo = '';
                let i = 0, j = 0;
                for (let o of order) {
                    if (o.boxNo) {
                        ++i;
                        boxNo = boxNo + o.boxNo + '，';
                    }
                    if (i === 2 && i < result.data.length - 1) {
                        boxNo = boxNo + '...';
                        break;
                    }
                }
                for (let o of order) {
                    if (o.factoryNo) {
                        ++j;
                        factoryNo = factoryNo + o.factoryNo + '，';
                    }
                    if (j === 2 && i < result.data.length - 1) {
                        factoryNo = factoryNo + '...';
                        break;
                    }
                }
                boxNo = splitStr(boxNo)
                factoryNo = splitStr(factoryNo)

                this.setState({
                    boxNo: boxNo,
                    factoryNo: factoryNo
                })
            }
            const {trailNo} = order;
            this.getOrderTrails(trailNo)
        } else {

        }
    }

    getPublicVehicle = (orderId) => {
        axios.get(baseUrl + '/api/v1/p/orderVehicle', { // 配置对象
            params: {orderId} // 指定请求参数
        }).then((res) => {
            var result = res.data;
            if (result.code === 200) {
                // debugger
                if (result.data && result.data.length > 0) {
                    let carNo = '';
                    for (let i = 0; i < result.data.length; i++) {
                        if (result.data[i].truckNo) { //车牌号
                            carNo = carNo + result.data[i].truckNo + '，';
                        }
                        if (i === 1 && i < result.data.length - 1) {
                            carNo = carNo + '...';
                            break;
                        }
                    }
                    carNo = splitStr(carNo)

                    this.setState({
                        carNo: carNo,
                    })
                }
            } else {
                message.error(result.message)
                return false;
            }
        });
    }

    // 查询轨迹信息
    getOrderTrails = async (trailNo) => {
        if (trailNo) {
            let result = await getOrderTrails(trailNo)
            if (result.code === 200) {
                this.setState({
                    deliveryTrailDo: result.data
                })
            } else {

            }
        }
    }

    componentWillMount() {
        if (this.props.location.state) {
            const id = this.props.location.state.id
            const orderId = this.props.location.state.id
            this.setState({
                id,
                orderId
            })
            this.getOrderDetails(id)
        } else {
            return
        }
    }

    setColletDt = (date) => {
        if (date) {
            this.setState({
                collectDt: date
            })
        }

    }

    render() {
        const steps = (this.state.supplierList || []).map(o => {
            if (o.indx != null) {
                return <Step title={o.positionCountry + ' ' + o.position}/>
            }
        });
        const {order} = this.state;
        return (
            <div className='trackInfo'>
                <div className="track-info-details box-shadow margin-bootom">
                    <Row className='track-info-item'>
                        <Col span={6}>
                            <span className='label'>订单编号：</span>
                            <span>{order.orderNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>揽收单位：</span>
                            <span>{order.entName}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>起运地：</span>
                            <span>{order.originCountry}</span>
                            &nbsp;&nbsp;
                            <span>{order.originCity}</span>
                        </Col>
                        <Col span={6}>
                            <span
                                className='label'>{PLAN_DELIVERY_TYPE.hasOwnProperty(order.deliveryType) ? '起始站' : '出境口岸'}：</span>
                            <span>{order.customsPortName}</span>
                        </Col>
                        {DELIVERY_TYPE_MIX.hasOwnProperty(order.deliveryType) ?
                            <Col span={6}>
                                <span
                                    className='label'>{PLAN_DELIVERY_TYPE.hasOwnProperty(order.deliveryType) || order.deliveryType === 'D' ? '目的站' : '转关地'}：</span>
                                <span>{order.internationalEndCountry} {order.internationalEndCity}</span>
                            </Col> : null}
                        {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(order.deliveryType) || DELIVERY_TYPE_AIR.hasOwnProperty(order.deliveryType) ?
                            <Col span={6}>
                                <span className='label'>清关地：</span>
                                <span>{order.customsClearanceCountry} {order.customsClearanceCity}</span>
                            </Col> : null}
                        {DELIVERY_TYPE_AIR.hasOwnProperty(order.deliveryType) ?
                            <Col span={6}>
                                <span className='label'>目的机场：</span>
                                <span>{order.internationalEndCountry} {order.internationalEndCity}</span>
                            </Col> : null}
                        <Col span={6}>
                            <span className='label'>目的地：</span>
                            <span>{order.destinationCountry}</span>
                            &nbsp;&nbsp;
                            <span>{order.destinationCity}</span>
                        </Col>
                        {DELIVERY_TYPE_AIR.hasOwnProperty(order.deliveryType) ? null :
                            <Col span={6}>
                                <span className='label'>还箱地：</span>
                                <span>{order.boxReturnStation}</span>
                            </Col>}
                        <Col span={6}>
                            <span className='label'>收货人：</span>
                            <span>{order.consignee}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>提货时间：</span>
                            <span>{order.collectDt}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>车牌号：</span>
                            <span>{order.truckNoIn} </span>
                            &nbsp;&nbsp;
                            <span>{order.truckNoOut} </span>

                        </Col>
                        <Col span={6}>
                            <span className='label'>集装箱号：</span>
                            <span>{order.boxNo}</span>
                        </Col>
                        <Col span={6}>
                            <span className='label'>厂封号：</span>
                            <span>{order.factoryNo}</span>
                        </Col>
                    </Row>
                </div>
                <div className='order-info box-shadow'>
                    <Row className='order-info-content' style={{border: 'none', padding: 0}}>
                        <Col span={24} className='order-info-content-left'>
                            <Tabs defaultActiveKey="1">
                                <TabPane tab="概况" key="1">
                                    <div className='general-part'>
                                        <Row className='general-part-item'>
                                            <Col span={3} className='general-part-item-title'>国内仓库地址：</Col>
                                            <Col span={9}>{order.deliveryPlace}</Col>
                                            <Col span={3} className='general-part-item-title'>预计提货时间：</Col>
                                            <Col span={9}>{order.deliveryEstimateDt}</Col>
                                        </Row>
                                        <Row className='general-part-item'>
                                            <Col span={3} className='general-part-item-title'>联系人：</Col>
                                            <Col span={9}>{order.contact}</Col>
                                            <Col span={3} className='general-part-item-title'>联系方式：</Col>
                                            <Col span={9}>{order.contactTel}</Col>
                                        </Row>
                                        <Row className='general-part-item'>
                                            <Col span={3} className='general-part-item-title'>清关仓库：</Col>
                                            <Col span={9}>{order.notifyParty}</Col>
                                            <Col span={3} className='general-part-item-title'>清关仓库地址：</Col>
                                            <Col span={9}>{order.notifyPartyAddr}</Col>
                                        </Row>
                                        <Row className='general-part-item'>
                                            <Col span={3} className='general-part-item-title'>目的仓库：</Col>
                                            <Col span={9}>{order.consignee}</Col>
                                            <Col span={3} className='general-part-item-title'>目的仓库地址：</Col>
                                            <Col span={9}>{order.consigneeAddr}</Col>
                                        </Row>
                                        <Row className='general-part-item'>
                                            <Col span={3} className='general-part-item-title'>联系人：</Col>
                                            <Col span={9}>{order.consignee}</Col>
                                            <Col span={3} className='general-part-item-title'>联系方式：</Col>
                                            <Col span={9}>{order.consigneeTel}</Col>
                                        </Row>
                                        {DELIVERY_TYPE_MIX.hasOwnProperty(order.deliveryType) ?
                                            <Row className='general-part-item'>
                                                <Col span={3} className='general-part-item-title'>提货时间：</Col>
                                                <Col span={9}>{order.collectDt}</Col>
                                                <Col span={3} className='general-part-item-title'>集装箱数：</Col>
                                                <Col span={9}>{order.containerNum}</Col>
                                            </Row> :
                                            <Row className='general-part-item'>
                                                <Col span={3} className='general-part-item-title'>提货时间：</Col>
                                                <Col span={9}>{order.collectDt}</Col>

                                            </Row>}
                                        {DELIVERY_TYPE_AIR.hasOwnProperty(order.deliveryType) ? null :
                                            <Row className='general-part-item'>
                                                <Col span={3} className='general-part-item-title'>租箱地：</Col>
                                                <Col span={9}>{this.state.boxRentStation}</Col>
                                                <Col span={3} className='general-part-item-title'>还箱地：</Col>
                                                <Col span={9}>{this.state.boxReturnStation}</Col>
                                            </Row>}
                                        <Row className='general-part-item'>
                                            <Col span={3} className='general-part-item-title'>运输类型：</Col>
                                            <Col span={9}>{DELIVERY_TYPE[order.deliveryType]}</Col>
                                            <Col span={3} className='general-part-item-title'>委托方式：</Col>
                                            <Col span={9}>
                                                {order.transferType === 'w2w' ?
                                                    <span>仓到仓 <Tooltip placement="rightBottom" title="全程都由我司承运。"><YgIcon
                                                        type="icon-wenhaow"/></Tooltip></span> : null}
                                                {order.transferType === 'w2s' ?
                                                    <span>仓到站 <Tooltip placement="rightBottom"
                                                                       title="从起运地到转关地由我司承运，从转关地到目的仓为贵司承运。">
                                                        <YgIcon type="icon-wenhaow"/></Tooltip></span> : null}
                                                {order.transferType === 's2s' ?
                                                    <span>站到站 <Tooltip placement="rightBottom"
                                                                       title="从起运地到口岸为贵司承运，从口岸到转关地由我司承运，从转关地到目的仓由贵司承运。"><YgIcon
                                                        type="icon-wenhaow"/></Tooltip></span> : null}
                                                {order.transferType === 's2w' ?
                                                    <span>站到仓 <Tooltip placement="rightBottom"
                                                                       title="从起运地到口岸为贵司承运，从口岸到目的仓由我司承运。"><YgIcon
                                                        type="icon-wenhaow"/></Tooltip></span> : null}
                                                {order.transferType === 'w2p' ?
                                                    <span>仓到口岸 <Tooltip placement="rightBottom"
                                                                        title="从起运地到口岸为我司承运，从口岸到目的仓由贵司承运。"><YgIcon
                                                        type="icon-wenhaow"/></Tooltip></span> : null}
                                                {order.transferType === 'p2p' ?
                                                    <span>口岸服务 <Tooltip placement="rightBottom"
                                                                        title="从起运地到口岸、从口岸到目的仓均为贵司承运。"><YgIcon
                                                        type="icon-wenhaow"/></Tooltip></span> : null}
                                                {order.transferType === 'w2as' ?
                                                    <span>仓到启运机场 <Tooltip placement="rightBottom"
                                                                          title="从起运地到启运机场为我司承运，从启运机场到目的仓为贵司承运。"><YgIcon
                                                        type="icon-wenhaow"/></Tooltip></span> : null}
                                                {order.transferType === 'w2a' ?
                                                    <span>仓到目的机场 <Tooltip placement="rightBottom"
                                                                          title="从起运地到目的机场为我司承运，从目的机场到目的仓为贵司承运。"><YgIcon
                                                        type="icon-wenhaow"/></Tooltip></span> : null}
                                                {order.transferType === 'p2as' ?
                                                    <span>口岸到启运机场 <Tooltip placement="rightBottom"
                                                                           title="从起运地到口岸为贵司承运，从口岸到启运机场为我司承运，从启运机场到目的仓为贵司承运。"><YgIcon
                                                        type="icon-wenhaow"/></Tooltip></span> : null}
                                                {order.transferType === 'p2a' ?
                                                    <span>口岸到目的机场 <Tooltip placement="rightBottom"
                                                                           title="从起运地到口岸为贵司承运，从口岸到目的机场为我司承运，从目的机场到目的仓为贵司承运。"><YgIcon
                                                        type="icon-wenhaow"/></Tooltip></span> : null}
                                                {order.transferType === 'p2w' ?
                                                    <span>口岸到仓 <Tooltip placement="rightBottom"
                                                                        title="从起运地到口岸为贵司承运，从口岸到目的仓为我司承运。"><YgIcon
                                                        type="icon-wenhaow"/></Tooltip></span> : null}

                                            </Col>
                                        </Row>
                                        <Row className='general-part-item'>
                                            <Col span={3} className='general-part-item-title'>保险：</Col>
                                            <Col span={9}>{order.insureFeeType == 'D' ? '我司代办' : '自办'}</Col>
                                            <Col span={3} className='general-part-item-title'>转关手续：</Col>
                                            <Col span={9}>{order.transitFeeType == 'D' ? '我司代办' : '自办'}</Col>
                                        </Row>
                                    </div>
                                    <Steps current={this.state.supplierList.length + 2} progressDot size='small'>
                                        {steps}
                                        {DELIVERY_TYPE_HIGHWAY.hasOwnProperty(order.deliveryType) ?
                                            <Step
                                                title={order.customsClearanceCountry + ' ' + order.customsClearanceCity}/> : null
                                        }
                                        <Step title={order.destinationCountry + ' ' + order.destinationCity}/>
                                    </Steps>,
                                </TabPane>
                                <TabPane tab="装车照片" key="3">
                                    <OrderFileComponent orderId={this.state.id} readonly={true}/>
                                </TabPane>
                                <TabPane tab="资料文件" key="4">
                                    <OrderBoxFile orderId={this.state.id} readonly={true}
                                                  deliveryType={order.deliveryType}
                                                  boxWeightData={{
                                                      cabinetCode: order.cabinetCode,
                                                      dskNo: order.dskNo,
                                                      dskDt: order.dskDt,
                                                      atbDt: order.atbDt
                                                  }}/>
                                </TabPane>
                            </Tabs>
                        </Col>
                    </Row>
                </div>
            </div>
        )
    }
}